import { useState, useEffect } from "react";
import { Star, Trophy, Horse, Lightning, TrendUp } from "@phosphor-icons/react";
import { fetchDailyTips } from "../lib/api";

export default function DailyTips() {
  const [tips, setTips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [racesAnalysed, setRacesAnalysed] = useState(0);

  useEffect(() => {
    fetchDailyTips().then((data) => {
      setTips(data.tips || []);
      setRacesAnalysed(data.total_races_analysed || 0);
    }).finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (!tips.length) return null;

  const medals = ["bg-[#D4AF37]", "bg-zinc-400", "bg-amber-700"];
  const labels = ["TOP PICK", "2ND PICK", "3RD PICK"];

  return (
    <section data-testid="daily-tips" className="mb-8 border border-zinc-800">
      <div className="bg-[#111] text-white px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Lightning weight="fill" size={16} className="text-[#D4AF37]" />
          <span className="mono-label text-[#D4AF37]">Today's Daily Tips</span>
        </div>
        <span className="text-[10px] font-mono text-zinc-600">{racesAnalysed} races analysed</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-zinc-800">
        {tips.map((tip, i) => (
          <div key={i} data-testid={`daily-tip-${i}`} className="p-4">
            <div className="flex items-center gap-2 mb-2">
              <span className={`${medals[i]} text-white text-[9px] font-mono font-bold uppercase px-2 py-0.5`}>
                {labels[i]}
              </span>
              <span className="text-[10px] font-mono text-zinc-400">{tip.time} {tip.track}</span>
            </div>
            <p className="text-sm font-semibold text-white">{tip.horse_name}</p>
            <p className="text-xs text-zinc-500 mb-2">{tip.jockey} &middot; {tip.trainer}</p>
            <div className="flex items-center gap-3 text-[10px] font-mono">
              <span className="bg-[#008A27] text-white px-2 py-0.5 font-bold">{tip.win_chance}%</span>
              <span className="text-zinc-400 flex items-center gap-0.5"><Trophy weight="fill" size={10} className="text-[#D4AF37]" />{tip.win_rate}% WR</span>
              {tip.jockey_win_rate > 0 && <span className="text-cyan-600">J:{tip.jockey_win_rate}%</span>}
              <span className="text-zinc-400">{tip.equiv_odds}</span>
            </div>
            <p className="text-[10px] text-zinc-500 mt-1">{tip.race_name} &middot; {tip.distance} &middot; {tip.going}</p>
          </div>
        ))}
      </div>
      <div className="px-4 py-2 bg-[#111] border-t border-zinc-800 text-[10px] font-mono text-zinc-500 text-center">
        Tips are AI-generated by RAW Company Tech's algorithm &mdash; not official bookmaker odds. Gamble responsibly. 18+
      </div>
    </section>
  );
}
